/**
 * Helpers for Silver plan SMS wallet responses (402 / smsWarning).
 */

export function getSmsInsufficientMessage(source) {
    if (!source) {
        return "Insufficient SMS units. Purchase units on Pricing.";
    }
    if (source.smsWarning && source.smsWarning.message) {
        return source.smsWarning.message;
    }
    if (source.message) {
        return source.message;
    }
    if (source.data && source.data.message) {
        return source.data.message;
    }
    return "Insufficient SMS units. Purchase units on Pricing.";
}

export function isSms402Error(err) {
    return !!(err && err.response && err.response.status === 402);
}

export function hasSmsWarning(data) {
    return !!(data && data.smsWarning);
}

export function applySmsResponseHandlers(res, { onInsufficient, onWarning } = {}) {
    if (res && res.status === 402) {
        if (onInsufficient) onInsufficient(getSmsInsufficientMessage(res.data));
        return { blocked: true, insufficient: true };
    }
    if (res && res.data && hasSmsWarning(res.data)) {
        if (onWarning) onWarning(getSmsInsufficientMessage(res.data));
        return { blocked: false, warning: true };
    }
    return { blocked: false };
}
